import Modal from "./Modal";

import PayPeriodEditor from "../editors/PayPeriodEditor";

const PayPeriodModal = ({ payPeriodId, open, onClose, onSave }) => {
  return (
    <Modal
      title={payPeriodId ? "payPeriod_update" : "payPeriod_new"}
      open={open}
      onClose={onClose}
      width="500px"
    >
      <PayPeriodEditor
        payPeriodId={payPeriodId}
        onSave={onSave}
      />
    </Modal>
  );
};

export default PayPeriodModal;
